export enum DiscountType {
  None,
  Cash,
  Percentage,
}

export const DiscountTypeLabel = new Map<number, string>([
  [DiscountType.Percentage, 'Porcentaje'],
  [DiscountType.Cash, 'Importe'],
]);

export enum SaleDiscountType {
  None,
  Sap,
  Coupon,
  Both,
}
